module.exports = __webpack_public_path__ + "img/Bin Sanitari Icon.bd3c92ff.png";